export default __webpack_public_path__ + "static/how-to-play-mobile-4f26c9089d015fb43a652154e4f701c6.png";